export enum ScheduleKind {
  ABSOLUTE = 'absolute',
  RELATIVE = 'relative',
}

export enum WaitDurationUnit {
  MINUTE = 'minute',
  HOUR = 'hour',
  DAY = 'calendarDay',
  WEEK = 'calendarWeek',
}
